
import { singleton as singleton_1, length, empty as empty_1, ofArray, map as map_1, isEmpty, tryFind, exists } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { createObj, equals } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { DTO_tryFindProcedureStep, DTO_isProcedureStepCompleted, ProcedureStepElementResultValue__ResultToString, ProcedureTemplateStepElementType } from "../../Shared/Procedure.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { nameOfKey, useDefinitions } from "../../InventoryStates/Display.js";
import { toString } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { replace, concat, join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { singleton, empty, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { unwrap, bind, map, defaultArg } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { toLocalTime, toString as toString_1 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { Helper_resolveDisplayValue } from "../../Shared/PropertyConfiguration.js";
import { SendEmailDispatch } from "../../Widgets/Procedure/Form/View.js";
import { Storage__get_DisplayName } from "../../Shared/Storage.js";
import { unwrapStorageId } from "../../Shared/Helper.js";
import { SectionContainer } from "../../Widgets/Container.js";
import { LabeledValue } from "../../Components/Text.js";
import { InventoryBaseState__ToI18nString, InventoryBaseStateModule_tryParse } from "../../Shared/InventoryStates.js";
import { update as update_1, init as init_1 } from "./State.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { DetailViewHeader } from "../../Widgets/DetailViewHeader.js";
import { RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { TextButton } from "../../Components/Button.js";
import { IconPaperclip } from "../../Components/Icon.js";
import { Msg } from "./Types.js";
import Printer from "../../../public/assets/icons/Printer.svg";
import { Skeleton } from "../../Components/Skeleton.js";

function canAttachProtocolPdf(form) {
    let matchValue;
    if ((matchValue = form.Procedure.State, (matchValue.tag === 2) ? true : ((matchValue.tag === 0) ? false : (!(matchValue.tag === 3))))) {
        return exists((step) => exists((element) => {
            if (equals(element.Type, new ProcedureTemplateStepElementType(14, []))) {
                return element.AttachProtocolPdf;
            }
            else {
                return false;
            }
        }, step.Elements), form.ProcedureTemplate.Steps);
    }
    else {
        return false;
    }
}

function StepResultElement(props) {
    let elems_4;
    const t = useTranslation()[0];
    const inventoryStates = useDefinitions();
    const result = tryFind((r) => (toString(r.ProcedureTemplateStepElementId) === props.ProcedureTemplateStepElement.Id), props.ProcedureStep.Results);
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-1"])], (elems_4 = toList(delay(() => append((props.ProcedureTemplateStepElement.Type.tag === 2) ? (empty()) : singleton(reactElement("div", {
        className: join(" ", ["font-bold", "mb-1"]),
        children: props.ProcedureTemplateStepElement.Label,
    })), delay(() => {
        let elems_1, elems_2, elems_3, matchValue_10, dispatch;
        const matchValue_1 = props.ProcedureTemplateStepElement.Type;
        switch (matchValue_1.tag) {
            case 1:
                return singleton(reactElement("div", {
                    className: join(" ", ["text-lg", "min-h-[28px]", "whitespace-pre-wrap", "break-words"]),
                    "data-test-id": concat("procedure-results-element-", ...props.ProcedureTemplateStepElement.Label),
                    children: defaultArg(map((_arg_1) => ProcedureStepElementResultValue__ResultToString(_arg_1.Value), result), "-"),
                }));
            case 2:
                return singleton(reactElement("div", {
                    className: join(" ", ["p-3", "bg-gray-100", "rounded", "whitespace-pre-wrap", "break-words"]),
                    children: props.ProcedureTemplateStepElement.Label,
                }));
            case 8: {
                const matchValue_3 = bind((r_1) => {
                    if (r_1.Value.tag === 6) {
                        return r_1.SignatureUrl;
                    }
                    else {
                        return undefined;
                    }
                }, result);
                if (matchValue_3 == null) {
                    return singleton(reactElement("div", {
                        className: join(" ", ["text-gray-400", "italic"]),
                        children: t("procedure.no_signature"),
                    }));
                }
                else {
                    const url = matchValue_3;
                    return singleton(reactElement("img", {
                        className: join(" ", ["h-24", "border", "rounded"]),
                        src: url,
                    }));
                }
            }
            case 5: {
                const boolValue = defaultArg(map((r_2) => {
                    const matchValue_4 = r_2.Value;
                    if (matchValue_4.tag === 3) {
                        if (matchValue_4.fields[0]) {
                            return t("general.yes");
                        }
                        else {
                            return t("general.no");
                        }
                    }
                    else {
                        return "-";
                    }
                }, result), "-");
                return singleton(reactElement("div", {
                    className: join(" ", ["text-lg", "min-h-[28px]"]),
                    children: boolValue,
                }));
            }
            case 6: {
                const dateValue = defaultArg(map((r_3) => {
                    const matchValue_5 = r_3.Value;
                    if (matchValue_5.tag === 4) {
                        return toString_1(toLocalTime(matchValue_5.fields[0]), "dd.MM.yyyy");
                    }
                    else {
                        return "-";
                    }
                }, result), "-");
                return singleton(reactElement("div", {
                    className: join(" ", ["text-lg", "min-h-[28px]"]),
                    children: dateValue,
                }));
            }
            case 9:
            case 11: {
                const selectValue = defaultArg(map((_arg_2) => ProcedureStepElementResultValue__ResultToString(_arg_2.Value), result), "-");
                return singleton(reactElement("div", {
                    className: join(" ", ["text-lg", "min-h-[28px]"]),
                    children: selectValue,
                }));
            }
            case 10: {
                const multiValues = defaultArg(map((_arg_3) => ProcedureStepElementResultValue__ResultToString(_arg_3.Value), result), "-");
                return singleton(reactElement("div", {
                    className: join(" ", ["text-lg", "min-h-[28px]"]),
                    children: multiValues,
                }));
            }
            case 12:
                return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems_1 = toList(delay(() => {
                    let elems;
                    return !isEmpty(props.ProcedureTemplateStepElement.Options) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-wrap", "gap-2"])], (elems = toList(delay(() => map_1((imageUrl) => reactElement("img", {
                        className: join(" ", ["rounded", "border", "max-w-full", "max-h-48", "object-contain"]),
                        src: imageUrl,
                    }), props.ProcedureTemplateStepElement.Options))), ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty();
                })), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
            case 13: {
                const photoUrls = defaultArg(map((_arg_4) => _arg_4.DocumentUrls, result), empty_1());
                return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-wrap", "gap-2"])], ["data-test-id", concat("procedure-results-photos-", ...props.ProcedureTemplateStepElement.Label)], (elems_2 = toList(delay(() => append(isEmpty(photoUrls) ? singleton(reactElement("div", {
                    className: join(" ", ["text-lg", "min-h-[28px]"]),
                    children: "-",
                })) : empty(), delay(() => map_1((url_1) => reactElement("img", {
                    className: join(" ", ["rounded", "border", "max-w-full", "max-h-48", "object-contain"]),
                    src: url_1,
                }), photoUrls))))), ["children", reactApi.Children.toArray(Array.from(elems_2))])]))));
            }
            case 14: {
                const inspectionValue = defaultArg(map((_arg_5) => ProcedureStepElementResultValue__ResultToString(_arg_5.Value), result), "-");
                return singleton(reactElement("div", {
                    className: join(" ", ["text-lg", "min-h-[28px]"]),
                    children: inspectionValue,
                }));
            }
            case 16: {
                let customFieldValue;
                const matchValue_6 = map((_arg_6) => _arg_6.Value, result);
                const matchValue_7 = props.ProcedureTemplateStepElement.PropertyConfigurationId;
                let matchResult, propertyConfigurationId, value_61, value_62;
                if (matchValue_6 == null) {
                    matchResult = 2;
                }
                else if (matchValue_6.tag === 14) {
                    if (matchValue_7 != null) {
                        matchResult = 0;
                        propertyConfigurationId = matchValue_7;
                        value_61 = matchValue_6.fields[0];
                    }
                    else {
                        matchResult = 1;
                        value_62 = matchValue_6;
                    }
                }
                else {
                    matchResult = 1;
                    value_62 = matchValue_6;
                }
                switch (matchResult) {
                    case 0: {
                        customFieldValue = Helper_resolveDisplayValue(props.Currency, props.PropertyConfigurations, propertyConfigurationId, value_61);
                        break;
                    }
                    case 1: {
                        customFieldValue = ProcedureStepElementResultValue__ResultToString(value_62);
                        break;
                    }
                    default:
                        customFieldValue = "-";
                }
                return singleton(reactElement("div", {
                    className: join(" ", ["text-lg", "min-h-[28px]"]),
                    "data-test-id": concat("procedure-results-custom-field-", ...props.ProcedureTemplateStepElement.Label),
                    children: customFieldValue,
                }));
            }
            case 15: {
                const documentCount = defaultArg(map((r_4) => (length(r_4.DocumentUrls) | 0), result), 0) | 0;
                const documentLabel = t("procedure.document_count");
                return singleton(reactElement("div", {
                    className: join(" ", ["text-sm", "text-gray-500"]),
                    children: `${documentCount} ${documentLabel}`,
                }));
            }
            case 17: {
                let displayText;
                const matchValue_9 = map((r_5) => r_5.Value, result);
                let matchResult_1, state;
                if (matchValue_9 != null) {
                    if (matchValue_9.tag === 15) {
                        if (matchValue_9.fields[0] == null) {
                            matchResult_1 = 1;
                        }
                        else {
                            matchResult_1 = 0;
                            state = matchValue_9.fields[0];
                        }
                    }
                    else {
                        matchResult_1 = 2;
                    }
                }
                else {
                    matchResult_1 = 2;
                }
                switch (matchResult_1) {
                    case 0: {
                        displayText = nameOfKey(t, inventoryStates, state);
                        break;
                    }
                    case 1: {
                        displayText = t("procedure.tool_state_change.no_change");
                        break;
                    }
                    default:
                        displayText = "-";
                }
                const displayComment = defaultArg(bind((_arg_7) => _arg_7.Comment, result), "");
                return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-1"])], (elems_3 = toList(delay(() => append(singleton(reactElement("div", {
                    className: join(" ", ["text-lg", "min-h-[28px]"]),
                    children: displayText,
                })), delay(() => ((displayComment !== "") ? singleton(reactElement("div", {
                    className: join(" ", ["text-sm", "text-gray-500"]),
                    children: displayComment,
                })) : empty()))))), ["children", reactApi.Children.toArray(Array.from(elems_3))])]))));
            }
            case 20:
                return singleton(createElement(SendEmailDispatch, {
                    Dispatch: unwrap((matchValue_10 = map((r_6) => r_6.Value, result), (matchValue_10 != null) ? ((matchValue_10.tag === 18) ? ((dispatch = matchValue_10.fields[0], dispatch)) : undefined) : undefined)),
                    Element: props.ProcedureTemplateStepElement,
                    IsTestMode: false,
                }));
            case 18: {
                let displayText_1;
                const matchValue_11 = map((r_7) => r_7.Value, result);
                let matchResult_2, transfer;
                if (matchValue_11 != null) {
                    if (matchValue_11.tag === 16) {
                        if (matchValue_11.fields[0] != null) {
                            matchResult_2 = 0;
                            transfer = matchValue_11.fields[0];
                        }
                        else {
                            matchResult_2 = 1;
                        }
                    }
                    else {
                        matchResult_2 = 1;
                    }
                }
                else {
                    matchResult_2 = 1;
                }
                switch (matchResult_2) {
                    case 0: {
                        const storageName = defaultArg(map(Storage__get_DisplayName, tryFind((storage) => (unwrapStorageId(storage.Id) === transfer.StorageId), props.Storages)), transfer.StorageId);
                        displayText_1 = ((transfer.StorageSpace !== "") ? concat(storageName, " (", transfer.StorageSpace, ...")") : storageName);
                        break;
                    }
                    default:
                        displayText_1 = "-";
                }
                return singleton(reactElement("div", {
                    className: join(" ", ["text-lg", "min-h-[28px]"]),
                    children: displayText_1,
                }));
            }
            case 19: {
                let completedCount;
                const matchValue_12 = map((r_8) => r_8.Value, result);
                let matchResult_3, ids;
                if (matchValue_12 != null) {
                    if (matchValue_12.tag === 17) {
                        matchResult_3 = 0;
                        ids = matchValue_12.fields[0];
                    }
                    else {
                        matchResult_3 = 1;
                    }
                }
                else {
                    matchResult_3 = 1;
                }
                switch (matchResult_3) {
                    case 0: {
                        completedCount = length(ids);
                        break;
                    }
                    default:
                        completedCount = 0;
                }
                const completedLabel = t("procedure.reminder_completion.completed_label");
                return singleton(reactElement("div", {
                    className: join(" ", ["text-lg", "min-h-[28px]"]),
                    children: `${completedCount} ${completedLabel}`,
                }));
            }
            case 7:
                return singleton(reactElement("div", {
                    className: join(" ", ["text-gray-400", "italic"]),
                    children: "-",
                }));
            default:
                return singleton(reactElement("div", {
                    className: join(" ", ["text-lg", "min-h-[28px]"]),
                    children: defaultArg(map((_arg) => ProcedureStepElementResultValue__ResultToString(_arg.Value), result), "-"),
                }));
        }
    })))), ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
}

function StepResult(props) {
    let elems_2, elems, elems_1;
    const t = useTranslation()[0];
    const isCompleted = DTO_isProcedureStepCompleted(props.ProcedureStep);
    const statusTestId = concat("procedure-results-step-status-", ...props.ProcedureTemplateStep.Name);
    return createElement(SectionContainer, {
        Content: reactElement("div", createObj(singleton_1((elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-2", "mb-4"])], (elems = toList(delay(() => (isCompleted ? singleton(reactElement("span", {
            className: join(" ", ["text-green", "text-sm"]),
            "data-test-id": statusTestId,
            children: t("procedure.completed"),
        })) : singleton(reactElement("span", {
            className: join(" ", ["text-gray-400", "text-sm"]),
            "data-test-id": statusTestId,
            children: t("procedure.not_completed"),
        }))))), ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems_1 = toList(delay(() => {
            const matchValue = props.ProcedureStep;
            if (matchValue == null) {
                return singleton(reactElement("div", {
                    className: join(" ", ["text-gray-400", "italic"]),
                    children: t("procedure.no_results"),
                }));
            }
            else {
                const procedureStep = matchValue;
                return map_1((element) => createElement(StepResultElement, {
                    Currency: props.Currency,
                    ProcedureStep: procedureStep,
                    ProcedureTemplateStepElement: element,
                    PropertyConfigurations: props.PropertyConfigurations,
                    Storages: props.Storages,
                }), props.ProcedureTemplateStep.Elements);
            }
        })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])))),
        Title: props.ProcedureTemplateStep.Name,
    });
}

function BookingSection(props) {
    let quantity_2, quantity_1, unit, elems_2, elems_1;
    const t = useTranslation()[0];
    const orDash = (value) => {
        if (value.trim() === "") {
            return "-";
        }
        else {
            return value;
        }
    };
    let bookingTypeKey;
    const matchValue = props.Booking.BookingType;
    bookingTypeKey = ((matchValue.tag === 1) ? "procedure.booking.type_return" : ((matchValue.tag === 2) ? "procedure.booking.type_transfer" : "procedure.booking.type_assignment"));
    const sideKey = (props.Booking.Side.tag === 1) ? "procedure.booking.side_receiver" : "procedure.booking.side_sender";
    const formatQuantity = (quantity) => replace(quantity.toString(), ".", ",");
    let quantity_3;
    const matchValue_2 = props.Booking.Quantity;
    const matchValue_3 = props.Booking.Unit;
    quantity_3 = ((matchValue_2 == null) ? undefined : ((matchValue_3 == null) ? ((quantity_2 = matchValue_2, formatQuantity(quantity_2))) : ((quantity_1 = matchValue_2, (unit = matchValue_3, concat(formatQuantity(quantity_1), " ", ...t(unit)))))));
    const fact = (label, value_1, testId) => {
        let elems;
        return reactElement("div", createObj(ofArray([["data-test-id", testId], (elems = [LabeledValue({
            Label: t(label),
            Value: value_1,
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
    };
    return reactElement("div", createObj(ofArray([["className", join(" ", ["border-t", "pt-4"])], ["data-test-id", "procedure-results-booking"], (elems_2 = [reactElement("div", {
        className: join(" ", ["text-sm", "font-bold", "mb-3"]),
        children: t("procedure.booking.title"),
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-2", "gap-4"])], (elems_1 = toList(delay(() => append(singleton(fact("procedure.booking.booking_type", concat(t(bookingTypeKey), " (", t(sideKey), ...")"), "procedure-results-booking-type")), delay(() => append(singleton(fact("procedure.booking.sender", orDash(props.Booking.SenderName), "procedure-results-booking-sender")), delay(() => append(singleton(fact("procedure.booking.receiver", orDash(props.Booking.ReceiverName), "procedure-results-booking-receiver")), delay(() => {
        let matchValue_5;
        return append((matchValue_5 = quantity_3, (matchValue_5 == null) ? (empty()) : singleton(fact("procedure.booking.quantity", matchValue_5, "procedure-results-booking-quantity"))), delay(() => append(singleton(fact("procedure.booking.storage", defaultArg(props.Booking.StorageName, "-"), "procedure-results-booking-storage")), delay(() => append(singleton(fact("procedure.booking.booking_date", toString_1(toLocalTime(props.Booking.BookingDate), "dd.MM.yyyy HH:mm"), "procedure-results-booking-date")), delay(() => (!isEmpty(props.Booking.SetItems) ? singleton(fact("procedure.booking.set_items", join(", ", map_1((_arg) => _arg.DisplayName, props.Booking.SetItems)), "procedure-results-booking-set-items")) : empty())))))));
    })))))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

function StateChangeSection(props) {
    let elems_2;
    const t = useTranslation()[0];
    const stateName = (state) => {
        const matchValue = InventoryBaseStateModule_tryParse(state.Key);
        if (matchValue == null) {
            return state.Name;
        }
        else {
            return t(InventoryBaseState__ToI18nString(matchValue));
        }
    };
    const fact = (label, value, testId) => {
        let elems;
        return reactElement("div", createObj(ofArray([["data-test-id", testId], (elems = [LabeledValue({
            Label: t(label),
            Value: value,
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
    };
    return reactElement("div", createObj(ofArray([["className", join(" ", ["border-t", "pt-4"])], ["data-test-id", "procedure-results-state-change"], (elems_2 = toList(delay(() => append(singleton(reactElement("div", {
        className: join(" ", ["text-sm", "font-bold", "mb-3"]),
        children: t("procedure.state_change.title"),
    })), delay(() => {
        let elems_1;
        const matchValue_1 = props.StateChange;
        if (matchValue_1.tag === 1) {
            return singleton(reactElement("div", {
                className: join(" ", ["text-sm", "text-gray-500"]),
                "data-test-id": "procedure-results-state-change-not-booked",
                children: t("procedure.state_change.not_booked"),
            }));
        }
        else {
            const stateChange = matchValue_1.fields[0];
            return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-2", "gap-4"])], (elems_1 = [fact("procedure.state_change.old_state", stateName(stateChange.OldState), "procedure-results-state-change-old"), fact("procedure.state_change.new_state", stateName(stateChange.NewState), "procedure-results-state-change-new"), fact("procedure.state_change.changed_at", toString_1(toLocalTime(stateChange.ChangedAt), "dd.MM.yyyy HH:mm"), "procedure-results-state-change-date"), fact("procedure.state_change.changed_by", defaultArg(stateChange.ChangedByName, "-"), "procedure-results-state-change-user")], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
        }
    })))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

export function ResultsView(props) {
    let elems_8;
    const t = useTranslation()[0];
    let patternInput_1;
    const init = init_1(props.ProcedureId);
    patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init, update_1, (_arg, _arg_1) => {
    }), undefined, [props.ProcedureId]);
    const state_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    let currency;
    const matchValue = state_1.CustomerConfiguration;
    currency = ((matchValue.tag === 1) ? matchValue.fields[0].Currency : "eUR");
    return reactElement("div", createObj(singleton_1((elems_8 = toList(delay(() => {
        const matchValue_1 = state_1.ProcedureForm;
        if (matchValue_1.tag === 1) {
            const form = matchValue_1.fields[0];
            return append(singleton(createElement(DetailViewHeader, {
                Badges: empty_1(),
                OnBack: () => {
                    RouterModule_nav(ofArray(["procedure-templates"]), 1, 1);
                },
                SubTitle: unwrap((form.ProcedureTemplate.Description !== "") ? form.ProcedureTemplate.Description : undefined),
                Title: form.ProcedureTemplate.Name,
            })), delay(() => {
                let elems_7;
                return append(singleton(createElement(SectionContainer, {
                    Content: reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-6"])], (elems_7 = toList(delay(() => {
                        let elems_3, elems_1, elems_2;
                        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-between", "items-start"])], (elems_3 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "gap-6"])], (elems_1 = toList(delay(() => append(singleton(LabeledValue({
                            Label: t("procedure.start_date"),
                            Value: toString_1(toLocalTime(form.Procedure.StartDate), "dd.MM.yyyy HH:mm"),
                        })), delay(() => {
                            let matchValue_2, endDate;
                            return append((matchValue_2 = form.Procedure.EndDate, (matchValue_2 == null) ? (empty()) : ((endDate = matchValue_2, singleton(LabeledValue({
                                Label: t("procedure.end_date"),
                                Value: toString_1(toLocalTime(endDate), "dd.MM.yyyy HH:mm"),
                            }))))), delay(() => {
                                let elems;
                                const matchValue_3 = form.PerformedBy;
                                if (matchValue_3 == null) {
                                    return empty();
                                }
                                else {
                                    const performedBy = matchValue_3;
                                    return singleton(reactElement("div", createObj(ofArray([["data-test-id", "procedure-results-performed-by"], (elems = [LabeledValue({
                                        Label: t("procedure.performed_by"),
                                        Value: performedBy,
                                    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))));
                                }
                            }));
                        })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "gap-2"])], (elems_2 = toList(delay(() => {
                            let Label;
                            return append(canAttachProtocolPdf(form) ? singleton(createElement(TextButton, (Label = t("procedure.attach_protocol_pdf"), {
                                ComponentState: state_1.FormState.IsLoading ? "disabled" : "enabled",
                                Icon: IconPaperclip(16),
                                Label: Label,
                                OnClick: () => {
                                    dispatch(new Msg(6, []));
                                },
                                TestId: "procedure-results-attach-protocol-button",
                                Variant: "default",
                            }))) : empty(), delay(() => {
                                let Label_1;
                                return singleton(createElement(TextButton, (Label_1 = t("procedure.download_pdf"), {
                                    ComponentState: state_1.FormState.IsLoading ? "disabled" : "enabled",
                                    Icon: Printer(),
                                    Label: Label_1,
                                    OnClick: () => {
                                        dispatch(new Msg(5, []));
                                    },
                                    TestId: "procedure-results-pdf-button",
                                    Variant: "default",
                                })));
                            }));
                        })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))), delay(() => {
                            let elems_6, elems_5;
                            return append(!isEmpty(form.InformationFieldValues) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["border-t", "pt-4"])], (elems_6 = [reactElement("div", {
                                className: join(" ", ["text-sm", "font-bold", "mb-3"]),
                                children: t("procedure.information_fields.title"),
                            }), reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-2", "gap-4"])], (elems_5 = toList(delay(() => map_1((fieldValue) => {
                                let elems_4;
                                return reactElement("div", createObj(ofArray([["data-test-id", concat("procedure-results-information-field-", ...fieldValue.Label)], (elems_4 = [LabeledValue({
                                    Label: t(fieldValue.Label),
                                    Value: (fieldValue.Value !== "") ? fieldValue.Value : "-",
                                })], ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
                            }, form.InformationFieldValues))), ["children", reactApi.Children.toArray(Array.from(elems_5))])])))], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))) : empty(), delay(() => {
                                let matchValue_4;
                                return append((matchValue_4 = form.Booking, (matchValue_4 == null) ? (empty()) : singleton(createElement(BookingSection, {
                                    Booking: matchValue_4,
                                }))), delay(() => {
                                    const matchValue_5 = form.StateChange;
                                    if (matchValue_5 == null) {
                                        return empty();
                                    }
                                    else {
                                        return singleton(createElement(StateChangeSection, {
                                            StateChange: matchValue_5,
                                        }));
                                    }
                                }));
                            }));
                        }));
                    })), ["children", reactApi.Children.toArray(Array.from(elems_7))])]))),
                })), delay(() => map_1((templateStep) => createElement(StepResult, {
                    Currency: currency,
                    ProcedureStep: unwrap(DTO_tryFindProcedureStep(form.Procedure, templateStep.Id)),
                    ProcedureTemplateStep: templateStep,
                    PropertyConfigurations: state_1.PropertyConfigurations,
                    Storages: state_1.Storages,
                }), form.ProcedureTemplate.Steps)));
            }));
        }
        else {
            return singleton(createElement(Skeleton, {
                Variant: "detail",
            }));
        }
    })), ["children", reactApi.Children.toArray(Array.from(elems_8))]))));
}

